.Content {
	display: block;
	padding: 20px var(--pad-x);
}
